/* eslint-disable */
import helpers from './helpers.js';

export default (function () {
  return {
    init() {
      // master-detail is the name of the ui pattern containing a list and associated detail section
      const masterDetails = document.querySelectorAll('.js-master-detail');
      if (!masterDetails.length) return;
      [...masterDetails].forEach((parent) => {
        let canAutoChange = true;
        const nodeList = parent.querySelectorAll(
          '.js-master-detail__list-item'
        );

        nodeList.forEach((item, index) => {
          if (index === 0 && helpers.breakpoint() !== 'mobile') {
            // Always automatically select the first item if not mobile
            // Template is already set to show first item content so no need to call updateDetailArea
            updateListItem(parent, item);
            if (helpers.breakpoint() !== 'mobile') {
              setInterval(() => {
                if (canAutoChange) {
                  autoChangeSelectedItem(parent, nodeList);
                }
              }, 6000);
            }
          } else if (helpers.breakpoint() === 'mobile') {
            // This is an important class which css selectors depend on to set
            // styles on the list item and its children for mobile
            helpers.addClass(item, 'js-is-mobile');
          }

          const ctaUrl = item.getAttribute('data-url');
          if (index === 0 && helpers.breakpoint() !== 'mobile') {
            // Hide cta if it does not contain a link, have to do this for the first one, this is handled
            // by updateDetailArea on subsequent changes
            const button = document.querySelector('.master-detail__content a');
            checkIfCtaShouldBeDisplayed(ctaUrl, button);
          } else {
            const button = item.querySelector(
              '.master-detail__content--mobile a'
            );
            checkIfCtaShouldBeDisplayed(ctaUrl, button);
          }

          const navButton = item.children[0];

          navButton.addEventListener('click', (e) => {
            e.preventDefault();
            // if the user has clicked on a menu item stop auto changing
            canAutoChange = false;
            helpers.removeClass(nodeList, 'can-auto-change');
            selectItem(parent, item);
          });
        });
      });

      function selectItem(parent, item) {
        updateListItem(parent, item);
        if (helpers.breakpoint() !== 'mobile') {
          // Detail area only exists on tablet/desktop
          updateDetailArea(parent, item);
        }
      }

      function autoChangeSelectedItem(parent, nodeList) {
        let item;
        const items = Array.prototype.slice.call(nodeList);
        const currentIndex = items.findIndex((item) =>
          item.classList.contains('isCurrent')
        );
        if (currentIndex === items.length - 1) {
          item = items[0];
        } else {
          item = items[currentIndex + 1];
        }
        selectItem(parent, item);
      }

      function updateListItem(parent, itemElement) {
        const isCurrent = itemElement.classList.contains('isCurrent');
        const isMobile = helpers.breakpoint() === 'mobile';
        const listItems = parent.querySelectorAll('.master-detail__list-item');
        const mobileContentWrapper = itemElement.querySelector(
          '.master-detail__content--mobile'
        );
        const mobileContent = itemElement.querySelector(
          '.master-detail-bg--mobile'
        );

        for (let item of listItems) {
          helpers.removeClass(item, 'isCurrent');
          const openDrawers = item.querySelector(
            '.master-detail__content--mobile'
          );
          openDrawers.style.height = 0;
        }

        if (!isCurrent) {
          helpers.addClass(itemElement, 'isCurrent');

          if (isMobile) {
            const expandedHeight =
              mobileContent.getBoundingClientRect().height || 0;

            mobileContentWrapper.style.height = `${expandedHeight}px`;
          }
        }
      }

      function updateDetailArea(parent, item) {
        const backgroundImageSource = item.getAttribute('data-bg-img');
        const title = item.getAttribute('data-title');
        const description = item.getAttribute('data-description');
        const ctaUrl = item.getAttribute('data-url');
        const cta = item.getAttribute('data-cta');
        const detailArea = document.querySelector('.master-detail__content');

        helpers.addClass(detailArea, 'fadeOutAndDown');

        helpers.prefixedEvent(detailArea, 'animationend', (e) => {
          helpers.removeClass(detailArea, 'fadeOutAndDown');

          // set background image
          const backgroundImageStyle = 'url("' + backgroundImageSource + '")';
          helpers.setStyle(parent, 'background-image', backgroundImageStyle);

          // set title
          detailArea.querySelector(
            '.js-master-detail__content-title'
          ).innerHTML = title;

          // set description
          detailArea.querySelector(
            '.js-master-detail__content-description'
          ).innerHTML = description;

          const button = detailArea.querySelector('a');
          checkIfCtaShouldBeDisplayed(ctaUrl, button);

          // set cta url
          detailArea.querySelector(
            '.js-master-detail__content-cta'
          ).parentNode.href = ctaUrl;

          // set cta text
          detailArea.querySelector(
            '.js-master-detail__content-cta'
          ).innerHTML = cta;

          helpers.addClass(detailArea, 'fadeInAndDown');
        });
      }

      function checkIfCtaShouldBeDisplayed(ctaUrl, button) {
        if (ctaUrl) {
          helpers.removeClass(button, 'u-hide');
        } else {
          helpers.addClass(button, 'u-hide');
        }
      }
    },
  };
})();
